import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './Static.css'
import FaqAccordion from '../../components/FaqAccordion/FaqAccordion'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'

export const Faq = () => {
  useEffect(() => {
    document.title = `FAQ | Staidium`;
  }, []);

  return (
    <>
      <Breadcrumb title='FAQ' />
      <div
        className='static-page'
        style={{
          background: 'rgb(18, 34, 45)',
          paddingTop: '90px',
          paddingBottom: '90px'
        }}>
        <Container>
          <Row>
            <Col lg={12}>
              <FaqAccordion title={''} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
